import { ApiGender, ApiInventory, ApiItemType } from '@ibe/api';
import HotelRoomView from './HotelRoomView';

export type ExactSearchDurationOptionsType = 'WEEKS' | 'NIGHTS';
export type PackageSearchDurationOptionsType = 'WEEKS' | 'NIGHTS';

export enum NoteLevelsType {
  GLOBAL = 'GLOBAL',
  SERVICE = 'SERVICE',
  UNIT = 'UNIT'
}

class ConfigModel {
  apiUrl: string;

  configUrl: string | null;

  translationsUrl: string;

  sessionKeyAuth: string;

  sessionKeyTabsShared: boolean;

  sessionKeyApp: string;

  sessionKeyCart: string;

  sessionKeyPackageCart: string;

  sessionKeySearchParams: string;

  sessionKeyCookieLaw: string;

  sessionKeyCurrency: string;

  sessionKeyDiscardedRecommendations: string;

  datePickerMinDateOffset: number;

  roomsLeftMaxToDisplay: number;

  offersLeftMaxToDisplay: number;

  defaultLanguage: string;

  defaultCountry?: string;

  formatDate: string;

  formatTime: string;

  googleApiKey: string | null;

  googleReCaptchaKey: string;

  defaultCurrency: string;

  currency: string;

  displayFormatDate: { [lang: string]: string };

  displayFormatDateShort: { [lang: string]: string };

  displayFormatWeekDay: { [lang: string]: string };

  displayFormatDateTime: { [lang: string]: string };

  googleAnalyticsTrackingId: string | null;

  googleTagManagerContainerId: string | null;

  useIndexedGeoUnits: boolean | false;

  useConsentManager: boolean | false;

  useTid: boolean | true;

  tenant: string | null;

  affiliate: string | null;

  pageToRoute: {
    [ApiItemType.HOTEL]: {
      page: string;
    };
  };

  session: {
    expirationTimeNotificationOffset: number;
    expirationTime?: number;
    guestExpirationTimeNotificationOffset?: number;
  };

  serviceCharacteristics: {
    [ApiItemType.EXTRA]: {
      language: string;
      exertionLevel: string;
    };
    [ApiItemType.HOTEL]: {
      amenities: string;
      facilities: string;
    };
  };

  unitOptions: {
    noSelection: string;
    showTAC: boolean;
  };

  theme: string | null;

  traveler: {
    genderValues: ApiGender[];
    maxChildAge: number;
    maxChildAgeFlightSearch?: number;
    maxInfantAge: number;
    mockAvailable: boolean;
    adjustRoomContainerToConfig?: boolean;
    treatInfantsAsChildren?: boolean;
  };

  headerScrollOffset: {
    mobile: number;
    tablet?: number;
    desktop: number;
  };

  stickyElementsOffset?: {
    mobile: {
      offset: number;
      breakpoint: number;
    };
    tablet: {
      offset: number;
      breakpoint: number;
    };
    desktop: {
      offset: number;
      breakpoint: number;
    };
  };

  scrollDuration: number;

  components: {
    voucherBuyerForm: {
      showFiscalCode: boolean;
      showState: boolean;
    };
    voucherPaymentSection: {
      showTaxes: boolean;
    };
    hotelRoomView: HotelRoomView;
    paxRoomSelection?: {
      disableButton: boolean;
    };
  };

  scrollOffsets: {
    header: number;
  };

  externalParam: {
    delimiter: string;
  };

  tracking: {
    hotjar: {
      hjid: number | null;
      hjsv: number | null;
    };
  };

  exactSearchDurationOptions?: Record<ExactSearchDurationOptionsType, number[]>;

  packageSearchDurationOptions?: Record<PackageSearchDurationOptionsType, number[]>;

  outsideElementsContainerId?: string;

  stickySearchOffsetClass?: string;

  forms?: {
    excludeSalutations?: string[];
    showConfirmEmailField?: boolean;
    registerForm?: {
      showAgencyNumberField?: boolean;
      maxTaxFieldLength?: number;
      minTaxFieldLength?: number;
    };
  };

  roundPricesToWholeNumber?:
    | 'DEFAULT_MODE'
    | 'ROUND_HALF_DOWN_MODE'
    | 'ROUND_DOWN_MODE'
    | 'ROUND_UP_MODE'
    | undefined;

  showCheckoutDocuments?: boolean;

  filterSortOption?: {
    SingleSelectionFilter?: Record<string, 'LABEL' | 'VALUE'>;
    GroupedMultipleSelectionFilter?: Record<string, Record<string, 'LABEL' | 'VALUE'>>;
    MultipleSelectionFilter?: Record<string, 'LABEL' | 'VALUE'>;
  };

  filterSortOptionOrder?: {
    SingleSelectionFilter?: Record<string, 'ASC' | 'DESC' | 'DEFAULT'>;
    GroupedMultipleSelectionFilter?: Record<string, 'ASC' | 'DESC' | 'DEFAULT'>;
    MultipleSelectionFilter?: Record<string, 'ASC' | 'DESC' | 'DEFAULT'>;
  };

  summaryComponentParams?: {
    packageItemType?: {
      showTitle?: boolean;
      filterNote?: boolean;
    };
  };

  noteSortingOrder?: NoteLevelsType[];

  hideTravelerForm?: boolean;

  enableMoveTicketLogic?: boolean;

  calendar: {
    weekStartsOn?: { [code: string]: 0 | 1 | 2 | 3 | 4 | 5 | 6 };
  };

  modalContainerClass: string;

  availabilityCalendarThreshold?: number;

  payment: {
    messagingEnabled?: boolean;
  };

  paxRoomConfig: {
    minAdults?: number;
    maxAdults?: number;
    maxChildren?: number;
    maxChildAge?: number;
    maxCapacity?: number;
    maxRooms?: number;
  };

  sanitizeConfig?: {
    allowIframes?: boolean;
  };

  internFlightInventories?: ApiInventory[];
}

export default ConfigModel;
